(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-community-questions"] && !Shopify.designMode) return;
  try {
    
  // Author: zoesvision.com
  // Purpose: Progressively reveal community question cards within this section.
  class ZCommunityQuestions extends HTMLElement {
    connectedCallback() {
      if (this.zReady) return;

      this.zReady = true;
      this.zButton = this.querySelector('[data-z-more]');
      this.zCards = [...this.querySelectorAll('[data-z-card]')];

      if (!this.zButton) return;

      const initialCount = Number(this.dataset.zInitialCount) || this.zCards.length;
      this.zCards.slice(initialCount).forEach((card) => {
        card.hidden = true;
      });

      this.zButton.hidden = this.zCards.length <= initialCount;
      this.zButton.addEventListener('click', this.zReveal);
    }

    disconnectedCallback() {
      this.zButton?.removeEventListener('click', this.zReveal);
      this.zReady = false;
    }

    zReveal = () => {
      const hiddenCards = this.zCards.filter((card) => card.hidden);
      const batchSize = Number(this.dataset.zBatchSize) || hiddenCards.length;

      hiddenCards.slice(0, batchSize).forEach((card) => {
        card.hidden = false;
      });

      if (hiddenCards.length <= batchSize) this.zButton.hidden = true;
    };
  }

  if (!customElements.get('z-community-questions')) {
    customElements.define('z-community-questions', ZCommunityQuestions);
  }

  } catch(e) { console.error(e); }
})();
})();
